import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  ButtonGroup,
  Collapse,
  IconButton
} from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import RestoreIcon from '@mui/icons-material/Restore';
import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { ChromePicker } from 'react-color';

const ColorControls = ({
  currentColor,
  backgroundColor,
  onColorChange,
  onBackgroundColorChange,
  onReset,
  onDownload
}) => {
  const [showLogoColor, setShowLogoColor] = useState(true);
  const [showBgColor, setShowBgColor] = useState(false);

  return (
    <Box>
      <Typography variant="h6" gutterBottom display="flex" alignItems="center" gap={1}>
        <PaletteIcon color="primary" />
        Color Controls
      </Typography>

      {/* Logo Color Picker */}
      <Box mb={3}>
        <Box 
          display="flex" 
          alignItems="center" 
          justifyContent="space-between"
          onClick={() => setShowLogoColor(!showLogoColor)}
          sx={{ cursor: 'pointer' }}
        >
          <Typography variant="subtitle1" display="flex" alignItems="center" gap={1}>
            <PaletteIcon fontSize="small" />
            Logo Color
          </Typography>
          <IconButton size="small">
            {showLogoColor ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        
        <Collapse in={showLogoColor}>
          <Box mt={1}>
            <ChromePicker
              color={currentColor}
              onChange={onColorChange}
              disableAlpha
            />
          </Box>
        </Collapse>
      </Box>

      {/* Background Color Picker */}
      <Box mb={3}>
        <Box 
          display="flex" 
          alignItems="center" 
          justifyContent="space-between"
          onClick={() => setShowBgColor(!showBgColor)}
          sx={{ cursor: 'pointer' }}
        >
          <Typography variant="subtitle1" display="flex" alignItems="center" gap={1}>
            <FormatColorFillIcon fontSize="small" />
            Background Color
          </Typography>
          <IconButton size="small">
            {showBgColor ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        
        <Collapse in={showBgColor}>
          <Box mt={1}>
            <ChromePicker
              color={backgroundColor}
              onChange={onBackgroundColorChange}
              disableAlpha
            />
          </Box>
        </Collapse>
      </Box>

      {/* Action Buttons */}
      <ButtonGroup fullWidth variant="outlined">
        <Button 
          startIcon={<RestoreIcon />}
          onClick={onReset}
          size="large"
        >
          Reset
        </Button>
        <Button 
          startIcon={<DownloadIcon />}
          onClick={onDownload}
          size="large"
          variant="contained"
        >
          Download
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default ColorControls;